import { defineMessages } from 'react-intl';

export default defineMessages({
  balanceInPhiat: { defaultMessage: 'Your balance' },
  loanToValue: { defaultMessage: 'Loan to value' },
});
